'use strict';
/* Polish layer: menu, letter-wave hover, card-to-detail transition, dialog exits.
   Timing follows one scale: open 380ms, close 260ms, ease-out-quint. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const q = s => document.querySelector(s);
  const wait = ms => new Promise(r => setTimeout(r, ms));
  const CLOSE_MS = 260;

  /* Letter wave: each character rolls up to an identical copy beneath it.
     The readable text stays in a hidden label, the split copy is aria-hidden. */
  document.querySelectorAll('[data-wave]').forEach(el => {
    const text = el.textContent;
    el.textContent = '';
    const label = document.createElement('span');
    label.className = 'visually-hidden';
    label.textContent = text;
    const roll = document.createElement('span');
    roll.className = 'wave';
    roll.setAttribute('aria-hidden', 'true');
    [...text].forEach((c, i) => {
      const ch = document.createElement('span');
      ch.className = 'ch';
      ch.style.setProperty('--i', i);
      ch.textContent = c === ' ' ? ' ' : c;
      roll.append(ch);
    });
    el.append(label, roll);
  });

  /* Menu */
  const menu = q('#site-menu'), button = q('#menu-button');
  // Split the category names too, so they share the hover wave.
  document.querySelectorAll('[data-wave-target]').forEach(el => {
    const text = el.textContent.replace(/\s+/g, ' ').trim(); el.textContent = '';
    el.innerHTML = `<span class="visually-hidden">${text}</span><span class="wave" aria-hidden="true">${[...text.trim()].map((c, i) => `<span class="ch" style="--i:${i}">${c === ' ' ? '&nbsp;' : c.replace('&', '&amp;').replace('<', '&lt;')}</span>`).join('')}</span>`;
  });

  let closing = false;
  function openMenu() {
    if (menu.open) return;
    menu.showModal();
    document.documentElement.classList.add('menu-open');
    button.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => menu.classList.add('is-open'));
    (matchMedia('(pointer:fine)').matches ? q('#menu-q') : q('#menu-close')).focus({ preventScroll: true });
  }
  async function closeMenu(after) {
    if (!menu.open || closing) return;
    closing = true;
    menu.classList.remove('is-open');
    menu.classList.add('is-closing');
    if (!reduce.matches) await wait(CLOSE_MS);
    menu.classList.remove('is-closing');
    menu.close();
    document.documentElement.classList.remove('menu-open');
    button.setAttribute('aria-expanded', 'false');
    closing = false;
    if (after) after(); else button.focus({ preventScroll: true });
  }
  window.opxMenu = { open: openMenu, close: closeMenu };
  button.addEventListener('click', openMenu);
  q('#menu-close').addEventListener('click', () => closeMenu());
  menu.addEventListener('cancel', e => { e.preventDefault(); closeMenu(); });

  /* Menu links are real links to collections and pages; search submits to the shop's search. */

  /* Cause and effect: an arrow from the action the visitor tapped to the part of the dashboard it changed. */
  const NS = 'http://www.w3.org/2000/svg';
  const layer = document.createElementNS(NS, 'svg');
  layer.setAttribute('class', 'demo-arrow');
  layer.setAttribute('aria-hidden', 'true');
  layer.innerHTML = '<defs><marker id="demo-head" viewBox="0 0 10 10" refX="7" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse"><path d="M1 1 L8 5 L1 9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></marker></defs><path class="demo-path" marker-end="url(#demo-head)"/>';
  document.body.append(layer);
  const path = layer.querySelector('.demo-path');
  const targets = { grocery: '.dashboard .kpi:nth-child(2)', save: '.dashboard .donut', dark: '.dashboard .dash-top h3' };
  let hideTimer, startY = 0, lastHit = null;
  const hide = () => { layer.classList.remove('is-on'); lastHit?.classList.remove('demo-hit'); };
  window.opxPoint = (button, kind) => {
    const target = q(targets[kind]);
    if (!target) return;
    const b = button.getBoundingClientRect(), r = target.getBoundingClientRect();
    if (!b.width || !r.width) return;
    const sx = b.left + b.width / 2, sy = b.top - 8;
    const ex = r.left + r.width / 2, ey = r.bottom + 10;
    const lift = Math.max(40, (sy - ey) * .45);
    path.setAttribute('d', `M${sx},${sy} C${sx},${sy - lift} ${ex + (sx - ex) * .25},${ey + lift} ${ex},${ey}`);
    const len = path.getTotalLength();
    path.style.strokeDasharray = len;
    clearTimeout(hideTimer);
    hide();
    path.style.transition = 'none';
    path.style.strokeDashoffset = reduce.matches ? 0 : len;
    layer.getBoundingClientRect();
    path.style.transition = '';
    layer.classList.add('is-on');
    path.style.strokeDashoffset = 0;
    target.classList.remove('demo-hit'); void target.offsetWidth; target.classList.add('demo-hit');
    lastHit = target;
    startY = scrollY;
    hideTimer = setTimeout(hide, 2800);
  };
  addEventListener('scroll', () => { if (layer.classList.contains('is-on') && Math.abs(scrollY - startY) > 24) hide(); }, { passive: true });
  addEventListener('resize', hide);

  /* Card to detail: the card's preview becomes the dialog's preview (shared element).
     Browsers without View Transitions get the dialog's own scale-and-fade. */
  const canMorph = () => 'startViewTransition' in document && !reduce.matches;
  let sourceVisual = null;
  window.opxOpenProduct = (trigger, dialog) => {
    sourceVisual = trigger.querySelector('.product-visual');
    const target = dialog.querySelector('.product-visual');
    if (!canMorph() || !sourceVisual || !target) { dialog.showModal(); return; }
    sourceVisual.style.viewTransitionName = 'product-visual';
    const vt = document.startViewTransition(() => {
      sourceVisual.style.viewTransitionName = '';
      target.style.viewTransitionName = 'product-visual';
      dialog.classList.add('no-entry');
      dialog.showModal();
    });
    vt.finished.finally(() => { target.style.viewTransitionName = ''; dialog.classList.remove('no-entry'); });
  };

  window.opxCloseDialog = async dialog => {
    if (dialog === menu) { closeMenu(); return; }
    if (!dialog.open || dialog.classList.contains('is-closing')) return;
    const visual = dialog.querySelector('.product-visual');
    if (dialog.id === 'product-dialog' && canMorph() && visual && sourceVisual?.isConnected) {
      visual.style.viewTransitionName = 'product-visual';
      const back = sourceVisual;
      const vt = document.startViewTransition(() => {
        visual.style.viewTransitionName = '';
        back.style.viewTransitionName = 'product-visual';
        dialog.close();
      });
      vt.finished.finally(() => { back.style.viewTransitionName = ''; });
      return;
    }
    if (reduce.matches) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    await wait(200);
    dialog.classList.remove('is-closing');
    dialog.close();
  };
})();
